import { render, staticRenderFns } from "./Pembayaran.vue?vue&type=template&id=5ad24887&scoped=true&"
import script from "./Pembayaran.vue?vue&type=script&lang=js&"
export * from "./Pembayaran.vue?vue&type=script&lang=js&"
import style0 from "./Pembayaran.vue?vue&type=style&index=0&id=5ad24887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad24887",
  null
  
)

export default component.exports